import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import {Suspense} from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {ErrorBoundary} from 'react-error-boundary';
import DiagCpoContentsLoading from '@di-shared/features/diag/cpo/DiagCpoContentsLoading';
import DiagCpoContentsError from '@di-shared/features/diag/cpo/DiagCpoContentsError';
import DiagCpoContents from '@di-shared/features/diag/cpo/DiagCpoContents';

export interface DiagCpoPageProps {
  vin: string;
}

function DiagCpoPage({vin}: DiagCpoPageProps) {
  const {t} = useInferableTranslation();

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T20078')}</h1>
      </Header>
      <ErrorBoundary fallback={<DiagCpoContentsError vin={vin} />}>
        <Suspense fallback={<DiagCpoContentsLoading />}>
          <DiagCpoContents vin={vin} />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}

export default DiagCpoPage;
